import Component from "../../../classes/Component";
import { $dom } from "../../../helpers/dom";
import { $events } from "../../../helpers/events";
import { $style } from "../../../helpers/style";
import { bsTargetAttr } from "../../../pages/utils/variables";
import Swiper, {Lazy, Navigation} from 'swiper';
import variables from "../../../variables";

const {classNames} = variables;
const rootElId = 'js-redragon-models';
const tabControlSelector = `#${rootElId} [data-bs-toggle="tab"]`;
const carouselSelector = '.js-redragon-models-carousel';

export default function () {
    return new Component({
        name: 'landingRedragonModels',
        requiredTargets: '#'+rootElId,
        onInit() {
            this.carousels = [];
            const initialActiveTabId = $dom.getAll(tabControlSelector)
                .find(c => $dom.hasClass(c, 'active'))
                ?.getAttribute(bsTargetAttr)
            ;                

            this.createCarousel = currentTab => {
                const carouselRoot = $dom.get(carouselSelector, currentTab);               
                
                if (carouselRoot && !carouselRoot.alreadyInititalized) {

                    this.carousels.push(
                        new Swiper(carouselRoot, {
                            modules: [Navigation, Lazy],
                            lazy: {
                                loadedClass: classNames.lazyLoaded,
                                preloaderClass: classNames.lazyPreloader,
                                loadPrevNext: true
                            },
                            spaceBetween: 10,
                            slidesPerView: 3,
                            breakpoints: {
                                0: {
                                    slidesPerView: 'auto',
                                    slidesOffsetAfter: $style.get($dom.get('.container'), 'paddingRight', true)
                                },
                                [variables.breakpoints.sm]: {
                                    slidesPerView: 2,
                                    slidesOffsetAfter: 0
                                },
                                [variables.breakpoints.lg]: {
                                    slidesPerView: 3,
                                }
                            },
                            navigation: {
                                prevEl: $dom.get('.js-redragon-models-prev', currentTab),
                                nextEl: $dom.get('.js-redragon-models-next', currentTab),
                            }
                        })
                    );                    
                    
                    carouselRoot.alreadyInititalized = true;
                }
            };

            this.handleTabChange = (e) => {
                const btn = e.target.closest(tabControlSelector);
                
                if (btn) {
                    const targetTabId = $dom.attr(btn, bsTargetAttr);
                    const targetTab = $dom.get(targetTabId, '#'+rootElId);

                    if (targetTab) this.createCarousel(targetTab);
                }
            };
            
            if ($dom.exist(initialActiveTabId)) 
                this.createCarousel($dom.get(initialActiveTabId));

            $events.delegate
                .on('shown.bs.tab', tabControlSelector, this.handleTabChange)
        },
        onDestroy() {
            this.carousels.forEach(c => {
                if(c instanceof Swiper) c.destroy();
            });

            this.carousels = [];

            $events.delegate
                .off('shown.bs.tab', tabControlSelector, this.handleTabChange)
        }        
    })
}
